
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

interface TemplateNameFieldProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const TemplateNameField: React.FC<TemplateNameFieldProps> = ({
  value,
  onChange,
  disabled = false
}) => {
  return (
    <div className="grid gap-2">
      <Label htmlFor="template-name">Template Name</Label>
      <Input 
        id="template-name" 
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="E.g., Weekend Special"
        disabled={disabled}
      />
    </div>
  );
};

export default TemplateNameField;
